import React from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import Header from './Header';
//import TeamModal from '../../../common/components/Team';
import { getColumns, getNoDataText, DEFAULTSORTED, DEFAULTPAGESIZE } from './table.conf.js';
import { withCookies } from 'react-cookie';
import { filter } from 'ramda';

const PurchaseOrders = (props) => {
  const { data, cookies } = props;

  // quick hack go show only this year data
  const currentYear = (new Date()).getYear().toString();
  
  const currentYearData = filter(({createdAt: c}) => c.substr(0, 4) === currentYear, data);
  
  return (
    <div>
      {/* <TeamModal */}
      {/*   modal={modal} */}
      {/*   /\* TODO seda vist ei ole vaja *\/ */}
      {/*   title='Team' */}
      {/*   onSave={onSave} */}
      {/*   onClose={onClose} */}
      {/* /> */}
      <Header/>
      <ReactTable
        className='-striped -highlight'
        data={currentYearData}
        /* getTrProps={(state, rowInfo) => ({ */
        /*   onClick: e => onOpen(null, rowInfo.original) */
        /* })} */
        columns={getColumns(cookies.get('lang') )}
        defaultSorted={DEFAULTSORTED}
        defaultPageSize={DEFAULTPAGESIZE}
        noDataText={getNoDataText()}
      />
    </div>
  );
};

export default withCookies(PurchaseOrders);



// WEBPACK FOOTER //
// ./src/private/user/components/PurchaseOrders/index.js